import { DollarSign, Calendar, Users, Zap } from 'lucide-react';

const LoanOfferings = () => {
  const offerings = [
    {
      title: "Competitive Rates",
      desc: "Access attractive interest rates from leading banks and NBFCs, ensuring affordability throughout your loan tenure",
      icon: <DollarSign size={48} />,
    },
    {
      title: "Flexible Terms",
      desc: "Choose repayment periods up to 30 years with customizable EMI options that fit your budget and lifestyle",
      icon: <Calendar size={48} />,
    },
    {
      title: "Comprehensive Support",
      desc: "Whether you're a first-time buyer, purchasing investment property, or refinancing, we provide expert guidance through every step",
      icon: <Users size={48} />,
    },
    {
      title: "Fast Processing",
      desc: "Streamlined documentation and quick approvals mean you can move into your dream home sooner",
      icon: <Zap size={48} />,
    },
  ];

  return (
    <section className="loan-offerings-section">
      {/* Title */}
      <h2 className="loan-offerings-title">
        Our Loan Offerings: <span>Home Loans</span>
      </h2>

      {/* Grid */}
      <div className="loan-offerings-grid">
        {offerings.map((item, index) => (
          <div key={index} className="loan-offering-item">
            <div className="loan-offering-icon">
              {item.icon}
            </div>

            <div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LoanOfferings;
